
import PropTypes from 'prop-types';
import { useForm, FormProvider, Controller, useFieldArray, get } from "react-hook-form";
import EmployerWork from "./EmployerWork";
import AreasOfWorkForm from "./AreasOfWorkForm"
import ViewUploadfile from './ViewUploadfile';
import { nationalities, countries } from '../../assets/nationalities';
import NumberChild from "./NumberChild";
import LanguageTagForm from "./LanguageTagForm"
import ContactInput from "./ContactInput";
import { useAuth } from '../../context/AuthContext';
import { getCurrencySymbol } from '../../assets/salaryformat';
//biodata=null for edit
import { useTranslation } from 'react-i18next';
const FormBiodata = ({ currentStep, methods, biodata = null }) => {

 const {user} = useAuth()
    const { getValues,handleSubmit, control, clearErrors, reset, register, watch, setError, setValue, trigger, formState: { errors } } = methods;

const { t } = useTranslation();

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        const updatedIllnesses = checked
            ? [...selectedIllnesses, value]
            : selectedIllnesses.filter((illness) => illness !== value);

        setValue("illnesses", updatedIllnesses);
    };

    const { fields, append, remove } = useFieldArray({
        control,
        name: "employment",
        keyName: '_id'
    });
    const selectedIllnesses = watch("illnesses", []);
    const selectedInterviewAvailable = watch("interview_availability", []); // Track selected values

    const handleCheckboxChangeInterviewAv = (e) => {
        const value = e.target.value;
        setValue(
            "interview_availability",
            e.target.checked
                ? [...selectedInterviewAvailable, value]
                : selectedInterviewAvailable.filter((av) => av !== value)
        );
    };


    return (
        <div className="tab-content" id="myTabContent">

            <div
                className={`tab-pane fade ${currentStep === 1 ? "active show" : ""}`}
                role="tabpanel"
                id="step1"
                aria-labelledby="step1-tab"
            >
                <div className="mb-4">
                    <h4>{t("(A) Profile of FDW")}</h4>
                </div>

                <div className="mb-4">
                    <h5>{t("A1 - Personal Information")}</h5>
                </div>
                <div className="row">

                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="code" className="form-label">{t("Reference Number")}</label>
                            <input type="text" id="code"  {...register("code")} className="form-control" />
                            <p className="text-danger biodata">{errors.code?.message}</p>
                        </div>

                        <div className="input-block mb-3">
                            <label htmlFor="name" className="form-label">{t("Full Name")}</label>
                            <input
                                {...register("name")}
                                type="text"
                                id="name"

                                className="form-control"

                            />
                            <p className="text-danger biodata">{errors.name?.message}</p>
                        </div>
                     <div className="input-block mb-3">
                            <label htmlFor="dob" className="form-label">{t("Date of Birth")}</label>
                            <input type="date"
                                data-date-format="DD MMMM YYYY"
                                onChange={(e) => setValue("dob", e.target.value || null)}
                                {...register("dob")}
                                id="dob" className="form-control" />
                            {/*biodata && biodata.dob && <label htmlFor="dob" className="form-label">
                                {biodata.dob}
                                <i

                                    className="text-primary  fe fe-edit ms-2"
                                    style={{ cursor: "pointer" }}

                                /></label>

                           */ }
                            <p className="text-danger biodata">{errors.dob?.message}</p>
                        </div>
                    </div>
                    <ViewUploadfile biodata={biodata} register={register} errors={errors} methods={methods} />

                </div>




                

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="pob" className="form-label">{t("Place of Birth")}</label>
                            <input type="text"
                                {...register("pob")}
                                id="pob" className="form-control" />
                            <p className="text-danger biodata">{errors.pob?.message}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="nationality" className="form-label">{t("Nationality")}</label>
                            <select
                                className="form-select"
                                id="nationality"
                                {...register("nationality")}
                                onChange={(e) => setValue("nationality", e.target.value || "")}

                            >
                                <option value="">{t("Select your nationality")}</option>
                                {nationalities.map((nation) => (
                                    <option key={nation} value={nation}>
                                        {nation}
                                    </option>
                                ))}
                            </select>
                            <p className="text-danger biodata">{errors.nationality?.message}</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="height" className="form-label">{t("Height (cm)")}</label>
                            <input type="text" inputMode="numeric"
                                {...register("height")}
                                id="height" className="form-control" />
                            <p className="text-danger biodata">{errors.height?.message}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="weight" className="form-label">{t("Weight (kg)")}</label>
                            <input type="text" inputMode="numeric"
                                {...register("weight")}
                                id="weight" className="form-control" />
                            <p className="text-danger biodata">{errors.weight?.message}</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="address" className="form-label">{t("Residential Address")}</label>
                            <textarea id="address" {...register("address")}
                                className="form-control"  >
                            </textarea>
                            <p className="text-danger biodata">{errors.address?.message}</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="airport" className="form-label">{t("Port/Airport for Repatriation")}</label>
                            <input type="text"  {...register("airport")} id="airport" className="form-control" />
                            <p className="text-danger biodata">{errors.airport?.message}</p>
                        </div>
                    </div>
                   { /*<div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="contact" className="form-label">Contact Number</label>
                            <input type="text" id="contact"  {...register("contact")} className="form-control" />
                            <p className="text-danger biodata">{errors.contact?.message}</p>
                        </div>
                    </div>*/}
                  <ContactInput country={user?.company?.country} setValue={setValue} getValues={getValues} register={register} errors={errors}  control={control} />
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="religion" className="form-label">{t("Religion")}</label>
                            <select id="religion" {...register("religion")} className="form-control" >
                                <option value="">{t("Select Religion")}</option>
                                <option value="Christian">{t("Christian")}</option>
                                <option value="Catholic">{t("Catholic")}</option>
                                <option value="Muslim">{t("Muslim")}</option>
                                <option value="Hindu">{t("Hindu")}</option>
                                <option value="Buddhist">{t("Buddhist")}</option>
                                <option value="Sikh">{t("Sikh")}</option>
                                <option value="Other">{t("Other")}</option>
                            </select>
                            <p className="text-danger biodata">{errors.religion?.message}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="education" className="form-label">{t("Education Level")}</label>
                            <input type="text"
                                {...register("education")}
                                id="education" className="form-control" />
                            <p className="text-danger biodata">{errors.education?.message}</p>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="siblings" className="form-label">{t("Number of Siblings")}</label>
                            <input type="number"  {...register("siblings")} id="siblings" className="form-control" />
                            <p className="text-danger biodata">{errors.siblings?.message}</p>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="marital" className="form-label">{t("Marital Status")}</label>
                            <select id="marital"  {...register("marital")} className="form-control" >
                                <option value="">{t("Select Marital Status")}</option>
                                <option value="Single">{t("Single")}</option>
                                <option value="Married">{t("Married")}</option>
                                <option value="Divorced">{t("Divorced")}</option>
                                <option value="Widowed">{t("Widowed")}</option>
                                <option value="Separated">{t("Separated")}</option>
                            </select>
                            <p className="text-danger biodata">{errors.marital?.message}</p>
                        </div>
                    </div>

                </div>

                <div className="row">
                   { /*<div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="children" className="form-label">Number of Children</label>
                            <input type="number" id="children" {...register("children")} className="form-control" />
                            <p className="text-danger biodata">{errors.children?.message}</p>
                        </div>
                    </div>*/}
                    <NumberChild getValues={getValues} register={register} errors={errors} control={control} />
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="passport" className="form-label">{t("Passport")}</label>
                            <input type="text" id="passport"  {...register("passport")} className="form-control" />
                            <p className="text-danger biodata">{errors.passport?.message}</p>
                        </div>
                        <div className="input-block form-check" >
                            <input
                                type="checkbox"
                                {...register("passport_check")}
                                id="passport_check"
                                className="form-check-input"
                            />
                            <label htmlFor="passport_check" className="form-check-label">{t("Passport Ready")}</label>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="salary" className="form-label">{t("Salary")} </label>
                            {/* <input type="text" id="salary"  {...register("salary")} className="form-control" /> */}


                            <div className="input-group mb-3">
                                <span className="input-group-text">S$</span>
                                <input type="number" className="form-control" { ...register("salaries.SGD") } aria-label="Amount (to the nearest dollar)" />
                                <span className="input-group-text">.00</span>
                            </div>

                            <div className="input-group mb-3">
                                <span className="input-group-text">RM</span>
                                <input type="number" className="form-control" { ...register("salaries.MYR") } aria-label="Amount (to the nearest dollar)" />
                                <span className="input-group-text">.00</span>
                            </div>

                            <p className="text-danger biodata">{errors.salary?.message}</p>
                        </div>
                    </div>


                </div>




            </div>

            {/** SECOND */}

            <div
                className={`tab-pane fade ${currentStep === 2 ? "active show" : ""}`}
                role="tabpanel"
                id="step2"
                aria-labelledby="step2-tab"
            >

                <div className="mb-4">
                    <h5>{t("A2 - Medical History/Dietary Restriction")}</h5>
                </div>


                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="allergies" className="form-label">{t("Allergies (if any)")}</label>
                            <input type="text" id="allergies" {...register("allergies")} className="form-control" />
                        </div>
                    </div>
                </div>

                <h6>{t("Past and Existing Illnesses")}</h6>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label className="form-label">{t("Including chronic ailments and illnesses requiring medication:")}</label>
                            <div className="form-check">
                                { /*     <input type="checkbox"
                        checked={selectedIllnesses.includes("mental")}
                        onChange={handleCheckboxChange}
                        id="mental" name="illness" value="mental" className="form-check-input" />
                    <label htmlFor="mental" className="form-check-label">Mental illness</label>*/}
                            </div>
                            {[
                                { id: "mental", label: t("Mental illness"),value: "Mental illness" },
                                { id: "epilepsy", label: t("Epilepsy"), value: "Epilepsy" },
                                { id: "asthma", label: t("Asthma"), value: "Asthma" },
                                { id: "diabetes", label: t("Diabetes") , value: "Diabetes" },
                                { id: "hypertension", label: t("Hypertension"), value: "Hypertension" },
                                { id: "tuberculosis", label: t("Tuberculosis") , value: "Tuberculosis" },
                                { id: "heart", label: t("Heart disease") , value: "Heart disease" },
                                { id: "malaria", label: t("Malaria") , value: "Malaria" },
                                { id: "operations", label: t("Operations"), value: "Operations" },
                            ].map(({ id, label ,value}) => (
                                <div className="form-check" key={id}>
                                    <input
                                        type="checkbox"
                                        {...register("illnesses")}
                                        value={value}
                                        checked={selectedIllnesses.includes(value)}
                                        onChange={handleCheckboxChange}
                                        id={id}
                                        className="form-check-input"
                                    />
                                    <label htmlFor={id} className="form-check-label">{label}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="disabilities" className="form-label">{t("Physical Disabilities")}</label>
                            <input type="text" id="disabilities" {...register("disabilities")} className="form-control" />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="diet" className="form-label">{t("Dietary Restrictions")}</label>
                            <input type="text" id="diet" {...register("diet")} className="form-control" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label className="form-label">{t("Food Handling Preferences")}</label>

                            <div className="form-check">
                                <input type="checkbox"  {...register("food_preference.pork")} id="no_pork" className="form-check-input" />
                                <label htmlFor="no_pork" className="form-check-label">{t("No pork")}</label>
                            </div>

                            <div className="form-check">
                                <input type="checkbox"  {...register("food_preference.beef")} id="no_beef" className="form-check-input" />
                                <label htmlFor="no_beef" className="form-check-label">{t("No beef")}</label>
                            </div>

                            <div className="input-block mt-3">
                                <label htmlFor="other_food_handling" className="form-label">{t("Others (please specify)")}</label>
                                <input type="text" {...register("food_preference.other")} id="other_food_handling" className="form-control" />
                            </div>
                        </div>
                    </div>
                </div><div className="my-4">
                    <h5>{t("A3 - Others")}</h5>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="rest_day" className="form-label">{t("Preferred Rest Days Per Month")}</label>
                            <input type="text" {...register("rest_day")} id="rest_day" className="form-control" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-block mb-3">
                            <label htmlFor="remarks" className="form-label">{t("Other Remarks")}</label>
                            <textarea id="remarks" {...register("remarks")} className="form-control"></textarea>
                        </div>
                    </div>
                </div>


            </div>

            {/** thrd */}

            <div
                className={`tab-pane fade ${currentStep === 3 ? "active show" : ""}`}
                role="tabpanel"
                id="step3"
                aria-labelledby="step3-tab"
            >
                <div className="mb-4">
                    <h4>{t("(B) Skills of FDW")}</h4>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            {/*<label className="form-label">Method of Evaluation of Skills</label>*/}
                            <div className="mb-4">
                                <h5>{t("B1 - Method of Evaluation of Skills")}</h5>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" id="fdw_declaration" {...register("fdw_declaration")} className="form-check-input" />
                                <label htmlFor="fdw_declaration" className="form-check-label">
                                    {t("Based on FDW’s declaration, no evaluation/observation by Singapore EA or overseas training centre/EA")}
                                </label>

                            </div>

                            <div className="form-check">
                                <input type="checkbox" id="singapore_ea"  {...register("singapore_ea")} className="form-check-input" />
                                <label htmlFor="singapore_ea" className="form-check-label">
                                    {t("Interviewed by Singapore EA")}
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="input-block mb-3">

                                    <label className="form-label my-3">{t("Interview Method")}</label>
                                    <p className="text-danger biodata">{errors.interview_method?.message}</p>
                                    {["Telephone", "Video", "In Person", "Observation"].map((method) => (
                                        <Controller
                                            key={method}
                                            name="interview_method"
                                            control={methods.control}
                                            render={({ field }) => (
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        id={`interview_${method}`}
                                                        value={method}
                                                        checked={field.value?.includes(method)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(
                                                                e.target.checked
                                                                    ? [...(field.value || []), value] // Add if checked
                                                                    : field.value.filter((item) => item !== value) // Remove if unchecked
                                                            );
                                                        }}
                                                        className="form-check-input"
                                                    />
                                                    <label htmlFor={`interview_${method}`} className="form-check-label">
                                                        {method === "Telephone" && "Interviewed via telephone/teleconference"}
                                                        {method === "Video" && "Interviewed via videoconference"}
                                                        {method === "In Person" && "Interviewed in person"}
                                                        {method === "Observation" && "Interviewed in person and also made observation of FDW"}
                                                    </label>
                                                </div>
                                            )}
                                        />
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mt-4">
                            <AreasOfWorkForm methods={methods} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mt-3">
                            <LanguageTagForm methods={methods} />

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block my-3">
                            <label className="form-label">{t("Interview by Overseas Training Centre / EA")}</label>

                            <div className="form-check">
                                <input {...register("overseas_training")} type="checkbox" id="overseas_training" className="form-check-input" />
                                <label htmlFor="overseas_training" className="form-check-label">
                                    {t("Interviewed by overseas training centre / EA")}
                                </label>
                            </div>

                            <div className="mt-3">
                                <label htmlFor="foreign_training_centre" className="form-label">{t("Name of Foreign Training Centre / EA")}</label>
                                <input type="text" {...register("foreign_training_centre")} id="foreign_training_centre" className="form-control" />
                            </div>

                            <div className="mt-3">
                                <label htmlFor="certification" className="form-label">{t("Third Party Certification (e.g. ISO9001) / Audit Details")}</label>
                                <input type="text" {...register("certification")} id="certification" className="form-control" />
                            </div>
                        </div>
                    </div>
                </div>



            </div>

            {/** fourth */}

            <div
                className={`tab-pane fade ${currentStep === 4 ? "active show" : ""}`}
                role="tabpanel"
                id="step4"
                aria-labelledby="step4-tab"
            >
                <div className="mb-4">
                    <h4>{t("(C) Employment History of the FDW")}</h4>
                </div>

                <div className="my-4"> <h5>{t("C1 - Employment History Overseas")}</h5></div>
                {
                    fields.map((field, index) => (
                        <EmployerWork
                            key={field.id}
                            workId={index}
                            methods={methods}
                            remove={remove}




                        />
                    ))

                }
                <div className="my-4">
                    <button className='btn btn-primary' onClick={(e) => {
                        e.preventDefault();
                        append({
                            employment_from: "",
                            employment_to: "",
                            employment_country: "",
                            employment_employer: "",
                            employment_duties: ""
                        });
                    }}>{t("Add Employment")}</button>
                </div>


                {/* C2: Employment History in Singapore */}
                <div className="my-4"> <h5>{t("C2 - Employment History in Singapore")}</h5></div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label className="form-label">{t("Previous working experience in Singapore")}</label>
                            <p className="text-danger biodata">{errors.singapore_experience?.message}</p>
                            <div className="form-check">
                                <input type="radio" id="singapore_yes" {...register("singapore_experience")} value="Yes" className="form-check-input" />
                                <label htmlFor="singapore_yes" className="form-check-label">{t("Yes")}</label>
                            </div>

                            <div className="form-check">
                                <input type="radio" id="singapore_no" {...register("singapore_experience")} value="No" className="form-check-input" />
                                <label htmlFor="singapore_no" className="form-check-label">{t("No")}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <p>{t("(The EA is required to obtain the FDW’s employment history from MOM and furnish the employer with the employment history of the FDW. The employer may also verify the FDW’s employment history in Singapore through WPOL using SingPass.)")}</p>

                {/* C3: Feedback from Previous Employers */}
                <div className="my-4">   <h5>{t("C3 - Feedback from Previous Employers in Singapore")}</h5> </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="feedback_employer_1" className="form-label">{t("Feedback from Employer 1")}</label>
                            <textarea id="feedback_employer_1"  {...register("feedback_employer_1")} className="form-control"></textarea>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="feedback_employer_2" className="form-label">{t("Feedback from Employer 2")}</label>
                            <textarea id="feedback_employer_2" {...register("feedback_employer_2")} className="form-control"></textarea>
                        </div>
                    </div>
                </div>

                {/* D: Availability for Interview */}
                <div className="my-4">
                    <h5>{t("(D) Availability of FDW to be Interviewed by Prospective Employer")}</h5>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label className="form-label">{t("Select Interview Availability")}</label>
                            <p className="text-danger biodata">{errors.interview_availability?.message}</p>
                            <div className="form-check">
                                <input checked={selectedInterviewAvailable.includes("Not-available")}
                                    onChange={handleCheckboxChangeInterviewAv}  {...register("interview_availability")} type="checkbox" id="not-available" name="interview_availability" value="Not-available" className="form-check-input" />
                                <label htmlFor="not-available" className="form-check-label">{t("FDW is not available for interview")}</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" checked={selectedInterviewAvailable.includes("Phone")}
                                    onChange={handleCheckboxChangeInterviewAv} {...register("interview_availability")} id="interview_phone" name="interview_availability" value="Phone" className="form-check-input" />
                                <label htmlFor="interview_phone" className="form-check-label">{t("FDW can be interviewed by phone")}</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" checked={selectedInterviewAvailable.includes("Video")}
                                    onChange={handleCheckboxChangeInterviewAv}  {...register("interview_availability")} id="interview_video" name="interview_availability" value="Video" className="form-check-input" />
                                <label htmlFor="interview_video" className="form-check-label">{t("FDW can be interviewed by video-conference")}</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" id="interview_person" checked={selectedInterviewAvailable.includes("In Person")}
                                    onChange={handleCheckboxChangeInterviewAv} {...register("interview_availability")} name="interview_availability" value="In Person" className="form-check-input" />
                                <label htmlFor="interview_person" className="form-check-label">{t("FDW can be interviewed in person")}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="my-4">
                    <h5>{t("(E) OTHER REMARKS")}</h5>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="input-block mb-3">
                            <label htmlFor="other_remarks" className="form-label">{t("Other Remarks")}</label>
                            <textarea id="other_remarks"{...register("other_remarks")} className="form-control" rows="4" ></textarea>
                        </div>
                    </div>
                </div>


            </div>

        </div>);
};
FormBiodata.propTypes = {
    biodata: PropTypes.object.isRequired,
    currentStep: PropTypes.number.isRequired,
    methods: PropTypes.shape({
        handleSubmit: PropTypes.func,
        clearErrors: PropTypes.func,
        reset: PropTypes.func,
        register: PropTypes.func,
        watch: PropTypes.func,
        setError: PropTypes.func,
        setValue: PropTypes.func,
        trigger: PropTypes.func,
        control: PropTypes.object.isRequired,
        getValues: PropTypes.func.isRequired,
        formState: PropTypes.shape({
            errors: PropTypes.object,
        }),
    }),
};

export default FormBiodata;   